export const Avatar = {};

export const CustomAvatar = {
	background: 'var(--epods--avatar-background)',
	size: 'var(--epods--avartar-size)',
	fontFamily: 'var(--epods--font-secondary)',
};
